// extracted by mini-css-extract-plugin
module.exports = {"main":"Loader_main__2T5_j","root":"Loader_root__3mgLs","spinner":"Loader_spinner__3LrM3"};